const $ = jQuery;

const InputNumber = {
  var: {
    min: 0,
    max: null,
    step: 1,
  },
  dom: { inputs: $('input[type="number"]') },
  increase: ($input) => {
    const currentVal = parseFloat($input.val());
    const newValue = currentVal + InputNumber.var.step;

    if (
      (InputNumber.var.max != null && newValue <= InputNumber.var.max) ||
      InputNumber.var.max == null
    ) {
      $input.val(newValue);
      $input.trigger("change");
    }
  },
  decrease: ($input) => {
    const currentVal = parseFloat($input.val());
    const newValue = currentVal - InputNumber.var.step;

    if (InputNumber.var.min <= newValue) {
      $input.val(newValue);
      $input.trigger("change");
    }
  },
  makeDom: () => {
    for (
      let index = 0;
      index < $('.quantity input[type="number"]').length;
      index++
    ) {
      const $inputWrapper = $('<div class="input-wrapper" />');
      const $this = $($('input[type="number"]')[index]);

      let $plus, $minus;

      if ($this.closest(".shop-pages").length > 0) {
        $plus = $('<span class="arrow-up icon">+</span>');
        $minus = $('<span class="arrow-down icon">-</span>');
      } else {
        $plus = $("<div class=plus>+</div>");
        $minus = $("<div class=minus>-</div>");
      }

      if ($this.attr("min") && $this.attr("min") !== "")
        InputNumber.var.min = parseFloat($this.attr("min"));
      if ($this.attr("max") && $this.attr("max") !== "")
        InputNumber.var.max = parseFloat($this.attr("max"));
      if ($this.attr("step") && $this.attr("step") !== "")
        InputNumber.var.step = parseFloat($this.attr("step"));

      $this.wrapAll($inputWrapper);

      const $parent = $this.parent();

      $parent.append($plus);
      $parent.append($minus);

      $plus.on("click", () => {
        InputNumber.increase($this);
      });
      $minus.on("click", () => {
        InputNumber.decrease($this);
      });
    }
  },
  init: function () {
    InputNumber.makeDom();
    $("body").on("updated_wc_div", function () {
      InputNumber.makeDom();
    });
  },
};

export default InputNumber;
